<template>
  <FormKit
    label="Distributor Name"
    name="distributorId"
    type="autocomplete"
    placeholder="Search by distributor name"
    :options="getDistributorHandler"
    selection-removable
    :option-loader="distributorOptionLoader"
    empty-message="None Found"
    @input="handleSelectAssignedTo"
    validation="required"
  >
    <template #option="{ option, classes }">
      <div :class="classes.option">
        <div class="flex">
          <span class="truncate">{{ option.label }}</span>
        </div>
      </div>
    </template></FormKit
  >
</template>

<script lang="ts">
import { type Paging, useApi } from "@modernary/mui/utils/api";
import { type PropType, defineComponent } from "vue";
import type { Distributor } from "../distributor/distributor";
import { getDistributors } from "../distributor/distributorApi";
import { getPaginatedAutocomplete } from "@modernary/mui/utils/helpers";
import { until } from "@vueuse/core";

export default defineComponent({
  name: "DistributorAutocomplete",
  components: {},
  props: {
    entity: {
      type: Object as PropType<{ distributorName?: string; distributorId?: string }>,
      required: true,
    },
    modelValue: {
      type: Object,
    },
  },
  emits: ["update:modelValue"],
  setup(props, context) {
    const helperMap = new Map();

    const distributorResultToOption = (val: Distributor) => {
      const result = {
        label: val.name,
        value: val.id,
        distributorName: val.name,
      };
      helperMap.set(val.id, result);
      return result;
    };

    const { exec: execGetDistributors } = useApi<Paging<Distributor>>(getDistributors, {
      responseAdapter: (response) => {
        return response.data;
      },
    });

    let abortVlpSearch: Function | null = null;

    const getDistributorHandler = getPaginatedAutocomplete(
      distributorResultToArray,
      execGetDistributors,
      abortVlpSearch,
    );

    function distributorResultToArray(items: Distributor[]) {
      return items.map((val) => distributorResultToOption(val));
    }

    const distributorOptionLoader = async (id: string | number, cachedOption: any) => {
      if (cachedOption) return cachedOption;

      await until(props.entity).toBeTruthy();
      if (props.entity?.distributorId == id) {
        let testDis = {
          distributorName: props.entity.distributorName,
        };
        context.emit("update:modelValue", testDis);
        return {
          label: props.entity.distributorName,
          value: props.entity.distributorId,
          distributorName: props.entity.distributorName,
        };
      }
    };

    function handleSelectAssignedTo(val: any) {
      if (props.entity && val != props.entity.distributorName) {
        const selectedDistributor = helperMap.get(val);
        const distributor = { ...selectedDistributor };
        delete distributor["label"];
        delete distributor["value"];

        context.emit("update:modelValue", distributor);
      }
    }
    return {
      distributorOptionLoader,
      handleSelectAssignedTo,
      getDistributorHandler,
    };
  },
});
</script>
